import { Delete, Get, Post, Put } from 'api/core/actions';
import type { TagDraft } from 'redux/modules/tags.types';
import type { Tag } from 'types/tag';
import { encodeUrlParams } from 'utils/url-params';

export interface GetTagOptions {
  filter?: 'active' | 'all' | 'archived';
  page?: number;
  perPage?: number;
}

export const tagsApi = {
  getAll: ({
    filter = 'all',
    perPage = 1000,
    page = 1,
  }: GetTagOptions = {}): Promise<Array<Tag>> => {
    const params = {
      filter,
      limit: perPage,
      offset: (page - 1) * perPage,
    };
    return Get(`labels.json${encodeUrlParams(params)}`, {});
  },

  get: (id: number): Promise<Tag> => {
    return Get(`labels/${id}.json`);
  },

  save: (label: TagDraft): Promise<Tag> => {
    const labelId = label.id;
    if (labelId) {
      return Put(`labels/${labelId}`, { label }, {});
    }
    return Post('labels', { label }, {});
  },

  delete(id: number): Promise<unknown> {
    return Delete(`labels/${id}`, {}, {});
  },
};
